import 'parsley';

export function InitScript_InquiryValidators() {
    /*
    window.ParsleyValidator
        .addValidator(
            // Name of our validator.
            'OnlyLetters',

            // `value` will be the value entered into the field.
            // `requirements` will be a prefName.
            function (value, requirement) {
                assert = new Validator.Assert().Regexp('^[ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ A-Za-z.-]{2,50}$');
                return assert.validate(value);
            },
            // priority.
            45
        )
        .addMessage('en', 'OnlyLetters', "Only letters are allowed.");
    */
    // NB: IMPORTANT! Be Carreful! Parsley (v.2.9.2) transforms and has mapping validator's name
    // html-attr of validator: data-parsley-only-letters=""
    // Validator key-name: onlyLetters
    window.Parsley.addValidator('onlyLetters', {
        //requirementType: 'string',
        validateString: function (value, requirement) {
            let regexp = Parsley.Utils.parse.regexp('^[ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ A-Za-z.-]{2,50}$');
            return regexp.test(value);
        },
        priority: 45,
        messages: {
            en: "Only letters are allowed."
        }
    });

}